import React from "react";
import { Link2 } from "lucide-react";
import { toast } from "react-toastify";
import { getSessionMainId } from "../utils/getCookie";
import { getCustomerPortalLoginUrl } from "../../utils/portalTenant";

export default function CustomerPortalLinkButton() {
  const handleCopy = async () => {
    const mainId = getSessionMainId();
    if (!mainId) {
      toast.error("Log in to admin first to copy your portal link.");
      return;
    }
    const url = getCustomerPortalLoginUrl(mainId);
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Customer portal link copied");
    } catch {
      toast.info(url);
    }
  };

  return (
    <button
      type="button"
      className="omsnewbutton-copy"
      onClick={handleCopy}
      title="Copy link for customers to view invoices and pay online"
      style={{ whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: "6px" }}
    >
      <Link2 size={16} />
      Portal link
    </button>
  );
}
